import { defineMessages } from 'react-intl';

export default defineMessages({
    bankAccount: {
        id: 'views.components.paymentPreference.Preauthorized Bank Account',
        defaultMessage: 'Preauthorized Bank Account',
    },
    accountType: {
        id: 'views.components.paymentPreference.Bank Account Type',
        defaultMessage: 'Bank Account Type',
    },
    accountNumber: {
        id: 'views.components.paymentPreference.Bank Account Number',
        defaultMessage: 'Account Number',
    },
    routingNumber: {
        id: 'views.components.paymentPreference.Transit Number',
        defaultMessage: 'Transit Number',
    },
    bankHolderName: {
        id: 'views.components.paymentPreference.Bank Holder Name',
        defaultMessage: 'Bank Holder Name',
    },
    InstitutionNo: {
        id: 'views.components.paymentPreference.Institution Number',
        defaultMessage: 'Institution Number',
    },
    InstitutionName: {
        id: 'views.components.paymentPreference.Institution Name',
        defaultMessage: 'Institution Name',
    },
    tooltipInstituteNo: {
        id: 'views.components.paymentPreference.Institution No tooltip msg',
        defaultMessage: 'The institution number - three digits - identifies your bank.',
    },
    tooltipTransitNo: {
        id: 'views.components.paymentPreference.Transit No tooltip msg',
        defaultMessage: 'The transit number - five digits - shows which branch you opened your account at.',
    },
    tooltipBankAccNo: {
        id: 'views.components.paymentPreference.BankAccNo tooltip msg',
        defaultMessage: 'The account number - seven to twelve digits - identifies your individual account.',
    },
    ValidateMsg: {
        id: 'views.components.paymentPreference.Validate',
        defaultMessage: 'Validate',
    },
    bankAccountNoInvalid: {
        id: 'views.components.paymentPreference.Bank account number should contain 7 to 12 digits',
        defaultMessage: 'Bank account number should contain 7 to 12 digits'
    },
    paymentMethodSaveFailed: {
        id: 'views.components.paymentPreference.Your payment method has not been saved',
        defaultMessage: 'Your payment method has not been saved'
    },
    paymentMethodSaveSuccess: {
        id: 'views.components.paymentPreference.Payment Method successfully added.',
        defaultMessage: 'Payment Method successfully added.'
    },
    fieldEmpty: {
        id: 'views.components.paymentPreference.Please fill all the mandatory fields.',
        defaultMessage: 'Please fill all the mandatory fields.'
    },
    billingMethodChangeError: {
        id: 'views.components.paymentPreference.Please contact system administrator',
        defaultMessage: 'Unable to save billing method changes. Please contact system administrator'
    },
    paymentStatus: {
        id: 'views.components.paymentPreference.Payment Status',
        defaultMessage: 'Payment Status'
    },
    paymentMethod: {
        id: 'views.components.paymentPreference.Payment Method',
        defaultMessage: 'Payment Method'
    },
    validationPass: {
        id: 'views.components.paymentPreference.Validation passed.',
        defaultMessage: 'Validation passed.'
    },
    bankPaymentOption: {
        id: 'views.components.paymentPreference.Preauthorized Bank Account',
        defaultMessage: 'Preauthorized Bank Account'
    },
    cancelBankUpdate: {
        id: 'views.components.paymentPreference.Cancel',
        defaultMessage: 'Cancel',
    },
    isPrimary: {
        id: 'views.components.paymentPreference.Primary',
        defaultMessage: 'Primary',
    }
});
